import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { useCollection, useIO, useLinked, useModel } from '@type-r/react';
import { NavTree, NavTreeItem, PageLayout, TopSection, CollapsableSection } from 'lqx-react/lib';
import * as React from 'react';
import { CompanyModel, RelationshipModel, Participant } from 'api';
import { ModulesTopSection } from './modules-top-section';
import { RelationshipTopSection } from './relationship-top-section';
import { RelationshipUsers } from './relationship-users';
import { Loading } from 'lqx-react/lib';
import { RelationshiptHeader } from './header';

export const EditRelationship = ({ relationshipId }) => {
    const $errorMessage = useLinked(null);
    const relationship = useModel( RelationshipModel );
    const companies = useCollection.of( CompanyModel );
    const hasRelationshipId = !isNaN(relationshipId);

    const isReady = useIO( async () => {
        const promises: any[] = [];

        if (hasRelationshipId) {
            relationship.id = relationshipId;
            promises.push(relationship.fetch({params: {loadIdentifiers: true}}));            
        } else {
            relationship.set({}, { parse: true });
            relationship.participants.add([new Participant({ role: 'Customer'}), new Participant({ role: 'Supplier'})]);
            promises.push(companies.fetch({params: {partial: true}}));
        }

        await Promise
            .all(promises)
            .catch(e => console.error(e));
    });

    const classes = useStyles();

    return isReady ? (
        <PageLayout
            menu = { <Menu hasRelationshipId={hasRelationshipId} /> }
            header = { <RelationshiptHeader relationship={relationship}/>}
            maxWidth="xl"
        >
            <>
                <RelationshipTopSection
                    relationship={relationship}
                    companies={companies}
                />
                <TopSection id="modules" title="Modules">
                    <ModulesTopSection
                        relationship={relationship}
                    />
                </TopSection>

                { hasRelationshipId ?
                    <TopSection id="users" title="Users">
                        <CollapsableSection
                            id="users-permissions"
                            title="Users permissions"
                        >
                        <RelationshipUsers
                            relationship={relationship}

                        />
                        </CollapsableSection>
                    </TopSection>
                : null }
            </>
        </PageLayout>
    ) : <Loading/>;
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            '& .MuiTextField-root': {
                margin: theme.spacing(1),
                width: '25ch',
            },
        },

        button: {
            margin: theme.spacing(1),
        }
    }),
);

const Menu = ({ hasRelationshipId }) =>
    <NavTree
        defaultExpanded={[
            "relationship",
            "modules",
            "invoice-management",
            "users",
            "customer",
            "workflow",
            "notifications"
        ]}
    >
        <NavTreeItem target="relationship" label="Relationship">
            <NavTreeItem target="relationship-information" label="Relationship Information" />
            <NavTreeItem target="relationship-attributes" label="Relationship Attributes" />
        </NavTreeItem>
        <NavTreeItem target="modules" label="Modules">
            <NavTreeItem target="order-management" label="Order Management" />
            <NavTreeItem target="invoice-management" label="Invoice Management">
                <NavTreeItem target="invoice-management-dispute" label="Dispute" />
                <NavTreeItem target="invoice-management-reconciliation" label="Reconciliation" />
            </NavTreeItem>
            <NavTreeItem target="cashflow-forecasting" label="Cashflow Forecasting" />
            <NavTreeItem target="relationship-dashboard" label="Relationship Dashboard"/>
        </NavTreeItem>
        { hasRelationshipId ?
            <NavTreeItem target="users" label="Users">
                <NavTreeItem target="users-permissions" label="Users permissions" />
            </NavTreeItem>
        : null }
        <NavTreeItem target="customer" label="Customer">
            <NavTreeItem target="customer-bank-account-information" label="Band Account Information" />
            <NavTreeItem target="customer-invoice-management-details" label="Invoice Management Details"/>
        </NavTreeItem>
        <NavTreeItem target="workflow" label="Workflow">
        </NavTreeItem>
        <NavTreeItem target="notifications" label="Notifications"></NavTreeItem>
    </NavTree>
